export const getCodeValue = state => state.CodeValue;
export const getSignalRState = state => state.SignalRState;
export const getDeviceStates = state => state.DeviceStates;
export const getDeviceUnfold = state => state.DeviceUnfold;
export const getUserState = state => state.UserState;
export const getEnergyState = state => state.EnergyState;
export const getDeviceAlarm = state => state.DeviceAlarm;
export const getUseGasState = state => state.UseGasState;
export const getUserItem = state => state.UserItem;
export const getThemeList = state => state.ThemeList;
export const getThemeCode = state => state.ThemeCode;
export const getHomeModeList = state => state.HomeModeList;


// WEBPACK FOOTER //
// ./src/store/getters.js